<template>
	<nk-page :commercialAccess="settings.commercialAccess" :policyClaims="settings.claim">
		<div class="form-container d-flex flex-column gap-10 h-100">
			<div class="nk-card d-flex align-items-center justify-content-center gap-15 flex-shrink-0">
				<div class="code-title">
					{{ currentData?.code }}
				</div>
				<div class="icon-title">
					<icon icon="arrow-left" group="duo" />
				</div>
				<div class="input-title">
					<nk-input :options="componentOptions.code" v-model="localData.code"></nk-input>
				</div>
			</div>
			<div v-if="settings.reviewComponent" class="nk-card bg-white-nk-page review-component-container">
				<component :is="settings.reviewComponent" :data="currentData" :options="settings.componentOptions"></component>
			</div>
		</div>
	</nk-page>
</template>
<script lang="ts">
	import { Personnel } from '@/classes/salary/personnel'
	import { Guid, IResponse } from '@/interfaces/base'
	import { defineComponent, markRaw } from 'vue'
	import PersonnelInfo from '~/components/form/salary/personnel/personnel-info.vue'
	import Merge from 'lodash/merge'
	import { FormModes } from '~/enums/system'
	import validators, { Checker } from '@/statics/validators'
	import $sc from '~/plugins/shortcut.collection.js'
	import cloneDeep from 'lodash/cloneDeep'
	import DocumentSingle from '@/views/documents/document-single.vue'

	export default defineComponent({
		name: 'update-code',
		modal: {
			size: 'custom',
			width: 1080,
			height: 800,
			stateUID: 'update-code'
		},
		props: {
			options: Object,
			data: Object,
		},
		components: {
			PersonnelInfo,
			DocumentSingle
		},
		data() {
			return {
				FormModes: FormModes,
				personnel: null as Personnel | null,
				localData: {
					code: ''
				},
				currentData: {
					code: ''
				} as any,
				settings: {
					id: '' as Guid,
					code: null,
					reviewComponent: null as any,
					getData: null as any,
					componentOptions: null,
					claim: '',
					commercialAccess: ''
				},
				validators: {
					code: validators('required'),
				},
				componentOptions: {
					code: {
						mode: 'strnumber',
						placeholder: this.$t('salary.personnel.f.new-code')
					}
				},
				saveButton: null as any
			}
		},
		created() {
			this.settings = Merge(this.settings, this.options)
			this.currentData = cloneDeep(this.data)
			this.saveButton = {
				title: this.$t('save'),
				shortcut: $sc.find('save'),
				isPrimary: false,
				disabled: false,
				icon: 'save',
				handle: () => {
					this.save().then((res: any) => {
						const changedData = { ...this.currentData, ...this.localData }
						this.resolve(changedData)
					})
				},
				policyClaims: this.settings.claim,
			}
		},
		mounted() {
			this.prepareWindow(this.$t('forms.update-code-title'), [this.saveButton])
		},
		methods: {
			markRaw,
			validateInputs() {
				let checker = new Checker((type: string) => this.$t(`salary.personnel.f.${type}`))
				let errors = checker.test(this.localData, this.validators)

				this.validationToast(errors)
				return errors.length === 0
			},
			save() {
				return new Promise((resolve, reject) => {
					if (this.validateInputs())
						resolve(true)
					else
						reject()
				})

			}
		}
	})

</script>
<style lang="less">
	@import (reference) '~/styles/site.config.less';


	.code-title {
		font-size: 24px !important;
		position: relative;
		top: 2px;
	}

	.icon-title {
		font-size: 24px;
		color: @primary;
		display: flex;
		align-items: center;
	}

	.input-title input {
		width: 100px !important;
		height: 35px !important;
		font-size: 18px;
		text-align: center;
	}

	.review-component-container {
		flex: 1 1 0;
		min-height: 0;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.bg-white-nk-page .nk-page {
		background-color: white;
		flex: 1 1 auto;
		min-height: 0;
		height: 100%;
	}
</style>